// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: data.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AnalysisColumnType, analysisColumnTypeFromJSON, analysisColumnTypeToJSON } from "./enums";
import { Header, ObservationProto } from "./metadata";

export const protobufPackage = "com.meritic.newton";

/** Representation of a data value. */
export interface DataValueProto {
  type?:
    | DataValueProto_Type
    | undefined;
  /**
   * Only one of the following is set, based on the type.
   * If the type is NULL, then no field is set.
   */
  i32?: number | undefined;
  i64?: number | undefined;
  d?: number | undefined;
  b?: boolean | undefined;
  s?: string | undefined;
}

/** All supported types of values. */
export enum DataValueProto_Type {
  NULL_VALUE = 0,
  INT32_VALUE = 1,
  INT64_VALUE = 2,
  DOUBLE_VALUE = 3,
  BOOLEAN_VALUE = 4,
  STRING_VALUE = 5,
  UNRECOGNIZED = -1,
}

export function dataValueProto_TypeFromJSON(object: any): DataValueProto_Type {
  switch (object) {
    case 0:
    case "NULL_VALUE":
      return DataValueProto_Type.NULL_VALUE;
    case 1:
    case "INT32_VALUE":
      return DataValueProto_Type.INT32_VALUE;
    case 2:
    case "INT64_VALUE":
      return DataValueProto_Type.INT64_VALUE;
    case 3:
    case "DOUBLE_VALUE":
      return DataValueProto_Type.DOUBLE_VALUE;
    case 4:
    case "BOOLEAN_VALUE":
      return DataValueProto_Type.BOOLEAN_VALUE;
    case 5:
    case "STRING_VALUE":
      return DataValueProto_Type.STRING_VALUE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataValueProto_Type.UNRECOGNIZED;
  }
}

export function dataValueProto_TypeToJSON(object: DataValueProto_Type): string {
  switch (object) {
    case DataValueProto_Type.NULL_VALUE:
      return "NULL_VALUE";
    case DataValueProto_Type.INT32_VALUE:
      return "INT32_VALUE";
    case DataValueProto_Type.INT64_VALUE:
      return "INT64_VALUE";
    case DataValueProto_Type.DOUBLE_VALUE:
      return "DOUBLE_VALUE";
    case DataValueProto_Type.BOOLEAN_VALUE:
      return "BOOLEAN_VALUE";
    case DataValueProto_Type.STRING_VALUE:
      return "STRING_VALUE";
    case DataValueProto_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Representation for a row in a dataset. */
export interface RowValuesProto {
  /** List of data values in the row. */
  data_values: DataValueProto[];
  /**
   * Light-weight representation of the data values as a json array string.
   * Examples of json string for an observation's data values:
   * |        Observation Query        |        Row values json array        |
   * |   quarterly(date) sum(revenue)  |     "[1475260200000, 2134.45]"      |
   * |                                 |     "[1483209000000, 2444.69]"      |
   * |                                 |     "[1490985000000, 3244.90]"      |
   * Note that the date values are epochs in milliseconds so that there is
   * no discrepancy and conflict due to the formatting. Clients can use
   * the epoch value and convert to date.
   */
  data_value_json_array?: string | undefined;
}

export interface ColumnHashProto {
  /** Id of the observation column to which this data belongs. */
  actuals_id?:
    | string
    | undefined;
  /** Id of the benchmark to which this data belongs. */
  benchmark_id?:
    | string
    | undefined;
  /** type of analysis column. */
  analysis_column_type?:
    | AnalysisColumnType
    | undefined;
  /** type if the column data corresponds to a material column, false otherwise. */
  is_material?:
    | boolean
    | undefined;
  /** Name of the column corresponding to this column hash. */
  column_name?: string | undefined;
}

/** Representation for the data of an observation column. */
export interface ColumnValuesProto {
  /**
   * List of data values in the observation column.
   * All the values in the column should be of same type.
   */
  data_values: DataValueProto[];
  /**
   * Light-weight representation of the data values as a json array string.
   * Examples of json string for different observation column's data values:
   * |  Observation Column  |            Column values json array              |
   * |      sum(revenue)    |           "[2134.45, 2444.69, 3244.90]"          |
   * |    quarterly(date)   |  "[1475260200000, 1483209000000, 1490985000000]" |
   * Note that the date values are epochs in milliseconds so that there is
   * no discrepancy and conflict due to the formatting. Clients can use
   * the epoch value and convert to date.
   */
  data_value_json_array?:
    | string
    | undefined;
  /** Id of column data. */
  column_id?: string | undefined;
  column_hash?:
    | ColumnHashProto
    | undefined;
  /** Index of the column in the observation data. */
  column_index?: number | undefined;
  analysis_column_type?: AnalysisColumnType | undefined;
}

/** Representation for an observation's data. */
export interface ObservationDataProto {
  /** Observation metadata corresponding to the given data. */
  observation?:
    | ObservationProto
    | undefined;
  /**
   * List of column-wise data for the given observation.
   * The order of columns in this list corresponds to the
   * ordering of the observation columns.
   */
  column_values_list: ColumnValuesProto[];
  /** List of benchmarks column. */
  benchmark_headers: Header[];
}

function createBaseDataValueProto(): DataValueProto {
  return { type: undefined, i32: undefined, i64: undefined, d: undefined, b: undefined, s: undefined };
}

export const DataValueProto: MessageFns<DataValueProto> = {
  encode(message: DataValueProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.i32 !== undefined) {
      writer.uint32(16).int32(message.i32);
    }
    if (message.i64 !== undefined) {
      writer.uint32(24).int64(message.i64);
    }
    if (message.d !== undefined) {
      writer.uint32(33).double(message.d);
    }
    if (message.b !== undefined) {
      writer.uint32(40).bool(message.b);
    }
    if (message.s !== undefined) {
      writer.uint32(50).string(message.s);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DataValueProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDataValueProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.i32 = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.i64 = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.d = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.b = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.s = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DataValueProto {
    return {
      type: isSet(object.type) ? dataValueProto_TypeFromJSON(object.type) : undefined,
      i32: isSet(object.i32) ? globalThis.Number(object.i32) : undefined,
      i64: isSet(object.i64) ? globalThis.Number(object.i64) : undefined,
      d: isSet(object.d) ? globalThis.Number(object.d) : undefined,
      b: isSet(object.b) ? globalThis.Boolean(object.b) : undefined,
      s: isSet(object.s) ? globalThis.String(object.s) : undefined,
    };
  },

  toJSON(message: DataValueProto): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = dataValueProto_TypeToJSON(message.type);
    }
    if (message.i32 !== undefined) {
      obj.i32 = Math.round(message.i32);
    }
    if (message.i64 !== undefined) {
      obj.i64 = Math.round(message.i64);
    }
    if (message.d !== undefined) {
      obj.d = message.d;
    }
    if (message.b !== undefined) {
      obj.b = message.b;
    }
    if (message.s !== undefined) {
      obj.s = message.s;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DataValueProto>, I>>(base?: I): DataValueProto {
    return DataValueProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DataValueProto>, I>>(object: I): DataValueProto {
    const message = createBaseDataValueProto();
    message.type = object.type ?? undefined;
    message.i32 = object.i32 ?? undefined;
    message.i64 = object.i64 ?? undefined;
    message.d = object.d ?? undefined;
    message.b = object.b ?? undefined;
    message.s = object.s ?? undefined;
    return message;
  },
};

function createBaseRowValuesProto(): RowValuesProto {
  return { data_values: [], data_value_json_array: undefined };
}

export const RowValuesProto: MessageFns<RowValuesProto> = {
  encode(message: RowValuesProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.data_values) {
      DataValueProto.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.data_value_json_array !== undefined) {
      writer.uint32(18).string(message.data_value_json_array);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RowValuesProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRowValuesProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data_values.push(DataValueProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data_value_json_array = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RowValuesProto {
    return {
      data_values: globalThis.Array.isArray(object?.data_values)
        ? object.data_values.map((e: any) => DataValueProto.fromJSON(e))
        : [],
      data_value_json_array: isSet(object.data_value_json_array)
        ? globalThis.String(object.data_value_json_array)
        : undefined,
    };
  },

  toJSON(message: RowValuesProto): unknown {
    const obj: any = {};
    if (message.data_values?.length) {
      obj.data_values = message.data_values.map((e) => DataValueProto.toJSON(e));
    }
    if (message.data_value_json_array !== undefined) {
      obj.data_value_json_array = message.data_value_json_array;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RowValuesProto>, I>>(base?: I): RowValuesProto {
    return RowValuesProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RowValuesProto>, I>>(object: I): RowValuesProto {
    const message = createBaseRowValuesProto();
    message.data_values = object.data_values?.map((e) => DataValueProto.fromPartial(e)) || [];
    message.data_value_json_array = object.data_value_json_array ?? undefined;
    return message;
  },
};

function createBaseColumnHashProto(): ColumnHashProto {
  return {
    actuals_id: undefined,
    benchmark_id: undefined,
    analysis_column_type: undefined,
    is_material: undefined,
    column_name: undefined,
  };
}

export const ColumnHashProto: MessageFns<ColumnHashProto> = {
  encode(message: ColumnHashProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.actuals_id !== undefined) {
      writer.uint32(10).string(message.actuals_id);
    }
    if (message.benchmark_id !== undefined) {
      writer.uint32(18).string(message.benchmark_id);
    }
    if (message.analysis_column_type !== undefined) {
      writer.uint32(24).int32(message.analysis_column_type);
    }
    if (message.is_material !== undefined) {
      writer.uint32(32).bool(message.is_material);
    }
    if (message.column_name !== undefined) {
      writer.uint32(42).string(message.column_name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnHashProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnHashProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.actuals_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.benchmark_id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.analysis_column_type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_material = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.column_name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnHashProto {
    return {
      actuals_id: isSet(object.actuals_id) ? globalThis.String(object.actuals_id) : undefined,
      benchmark_id: isSet(object.benchmark_id) ? globalThis.String(object.benchmark_id) : undefined,
      analysis_column_type: isSet(object.analysis_column_type)
        ? analysisColumnTypeFromJSON(object.analysis_column_type)
        : undefined,
      is_material: isSet(object.is_material) ? globalThis.Boolean(object.is_material) : undefined,
      column_name: isSet(object.column_name) ? globalThis.String(object.column_name) : undefined,
    };
  },

  toJSON(message: ColumnHashProto): unknown {
    const obj: any = {};
    if (message.actuals_id !== undefined) {
      obj.actuals_id = message.actuals_id;
    }
    if (message.benchmark_id !== undefined) {
      obj.benchmark_id = message.benchmark_id;
    }
    if (message.analysis_column_type !== undefined) {
      obj.analysis_column_type = analysisColumnTypeToJSON(message.analysis_column_type);
    }
    if (message.is_material !== undefined) {
      obj.is_material = message.is_material;
    }
    if (message.column_name !== undefined) {
      obj.column_name = message.column_name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnHashProto>, I>>(base?: I): ColumnHashProto {
    return ColumnHashProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnHashProto>, I>>(object: I): ColumnHashProto {
    const message = createBaseColumnHashProto();
    message.actuals_id = object.actuals_id ?? undefined;
    message.benchmark_id = object.benchmark_id ?? undefined;
    message.analysis_column_type = object.analysis_column_type ?? undefined;
    message.is_material = object.is_material ?? undefined;
    message.column_name = object.column_name ?? undefined;
    return message;
  },
};

function createBaseColumnValuesProto(): ColumnValuesProto {
  return {
    data_values: [],
    data_value_json_array: undefined,
    column_id: undefined,
    column_hash: undefined,
    column_index: undefined,
    analysis_column_type: undefined,
  };
}

export const ColumnValuesProto: MessageFns<ColumnValuesProto> = {
  encode(message: ColumnValuesProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.data_values) {
      DataValueProto.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.data_value_json_array !== undefined) {
      writer.uint32(18).string(message.data_value_json_array);
    }
    if (message.column_id !== undefined) {
      writer.uint32(26).string(message.column_id);
    }
    if (message.column_hash !== undefined) {
      ColumnHashProto.encode(message.column_hash, writer.uint32(34).fork()).join();
    }
    if (message.column_index !== undefined) {
      writer.uint32(40).int32(message.column_index);
    }
    if (message.analysis_column_type !== undefined) {
      writer.uint32(48).int32(message.analysis_column_type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ColumnValuesProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColumnValuesProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data_values.push(DataValueProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data_value_json_array = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.column_id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.column_hash = ColumnHashProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.column_index = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.analysis_column_type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ColumnValuesProto {
    return {
      data_values: globalThis.Array.isArray(object?.data_values)
        ? object.data_values.map((e: any) => DataValueProto.fromJSON(e))
        : [],
      data_value_json_array: isSet(object.data_value_json_array)
        ? globalThis.String(object.data_value_json_array)
        : undefined,
      column_id: isSet(object.column_id) ? globalThis.String(object.column_id) : undefined,
      column_hash: isSet(object.column_hash) ? ColumnHashProto.fromJSON(object.column_hash) : undefined,
      column_index: isSet(object.column_index) ? globalThis.Number(object.column_index) : undefined,
      analysis_column_type: isSet(object.analysis_column_type)
        ? analysisColumnTypeFromJSON(object.analysis_column_type)
        : undefined,
    };
  },

  toJSON(message: ColumnValuesProto): unknown {
    const obj: any = {};
    if (message.data_values?.length) {
      obj.data_values = message.data_values.map((e) => DataValueProto.toJSON(e));
    }
    if (message.data_value_json_array !== undefined) {
      obj.data_value_json_array = message.data_value_json_array;
    }
    if (message.column_id !== undefined) {
      obj.column_id = message.column_id;
    }
    if (message.column_hash !== undefined) {
      obj.column_hash = ColumnHashProto.toJSON(message.column_hash);
    }
    if (message.column_index !== undefined) {
      obj.column_index = Math.round(message.column_index);
    }
    if (message.analysis_column_type !== undefined) {
      obj.analysis_column_type = analysisColumnTypeToJSON(message.analysis_column_type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ColumnValuesProto>, I>>(base?: I): ColumnValuesProto {
    return ColumnValuesProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColumnValuesProto>, I>>(object: I): ColumnValuesProto {
    const message = createBaseColumnValuesProto();
    message.data_values = object.data_values?.map((e) => DataValueProto.fromPartial(e)) || [];
    message.data_value_json_array = object.data_value_json_array ?? undefined;
    message.column_id = object.column_id ?? undefined;
    message.column_hash = (object.column_hash !== undefined && object.column_hash !== null)
      ? ColumnHashProto.fromPartial(object.column_hash)
      : undefined;
    message.column_index = object.column_index ?? undefined;
    message.analysis_column_type = object.analysis_column_type ?? undefined;
    return message;
  },
};

function createBaseObservationDataProto(): ObservationDataProto {
  return { observation: undefined, column_values_list: [], benchmark_headers: [] };
}

export const ObservationDataProto: MessageFns<ObservationDataProto> = {
  encode(message: ObservationDataProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.observation !== undefined) {
      ObservationProto.encode(message.observation, writer.uint32(10).fork()).join();
    }
    for (const v of message.column_values_list) {
      ColumnValuesProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.benchmark_headers) {
      Header.encode(v!, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ObservationDataProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseObservationDataProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.observation = ObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.column_values_list.push(ColumnValuesProto.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.benchmark_headers.push(Header.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ObservationDataProto {
    return {
      observation: isSet(object.observation) ? ObservationProto.fromJSON(object.observation) : undefined,
      column_values_list: globalThis.Array.isArray(object?.column_values_list)
        ? object.column_values_list.map((e: any) => ColumnValuesProto.fromJSON(e))
        : [],
      benchmark_headers: globalThis.Array.isArray(object?.benchmark_headers)
        ? object.benchmark_headers.map((e: any) => Header.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ObservationDataProto): unknown {
    const obj: any = {};
    if (message.observation !== undefined) {
      obj.observation = ObservationProto.toJSON(message.observation);
    }
    if (message.column_values_list?.length) {
      obj.column_values_list = message.column_values_list.map((e) => ColumnValuesProto.toJSON(e));
    }
    if (message.benchmark_headers?.length) {
      obj.benchmark_headers = message.benchmark_headers.map((e) => Header.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ObservationDataProto>, I>>(base?: I): ObservationDataProto {
    return ObservationDataProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ObservationDataProto>, I>>(object: I): ObservationDataProto {
    const message = createBaseObservationDataProto();
    message.observation = (object.observation !== undefined && object.observation !== null)
      ? ObservationProto.fromPartial(object.observation)
      : undefined;
    message.column_values_list = object.column_values_list?.map((e) => ColumnValuesProto.fromPartial(e)) || [];
    message.benchmark_headers = object.benchmark_headers?.map((e) => Header.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
